export enum HttpMethods {
  GET = 'get',
  POST = 'post',
  DELETE = 'del',
  PATCH = 'patch',
  PUT = 'put'
}
